<template>
	<v-navigation-drawer
		v-model="showPanel"
		:width="clientWidth"
		fixed
		right
		temporary
		class="recent-announced-prize-picker"
		@input="handleDrawerToggled">

		<template v-if="loading">
			<v-layout fill-height align-center justify-center ma-0>
				<v-progress-circular :indeterminate="loading"></v-progress-circular>
			</v-layout>
		</template>
		<template v-else>
			<v-card class="preview-panel">
				<v-toolbar color="grey lighten-2" flat v-if="title">
				    <v-toolbar-title class="grey--text text--darken-4" v-html="title"></v-toolbar-title>
				    <v-spacer></v-spacer>
				    <v-btn icon light>
				        <v-icon color="grey darken-2" @click.stop="handleClose">close</v-icon>
				    </v-btn>
				</v-toolbar>

				<v-card-text>
					<prize-list 
						:selected-prizes="selectedPrizes"
						:action="handlePickerAction">
					</prize-list>
				</v-card-text>

				<v-card-actions v-if="actionButtons" class="px-4">
					<template v-for="(action, index) in buttonsOnLeft">
						<v-btn v-bind="action.options" :text="action.options.text" @click="handleActionClick(action)" class="mt-12">{{ action.text }}</v-btn>
					</template>
					<v-spacer></v-spacer>
					<template v-for="(action, index) in buttonsOnRight">
						<v-btn v-bind="action.options" :text="action.options.text" @click="handleActionClick(action)" class="mt-12">{{ action.text }}</v-btn>
					</template>					
				</v-card-actions>
			</v-card>
		</template>
	</v-navigation-drawer>	
</template>

<script>
	import * as config from '@/config'

	import PrizeList from '@/components/PrizeList'

	export default {
		components: {
			PrizeList
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			title: {
				type: String,
				default: ''
			},
			selectedPrizes: {
				type: [Array],
				default: () => []
			},
			actionButtons: {
				type: Array,
				default: () => []
			}
		},
		data () {
			return {
				showPanel: false,
				loading: false,
				content: null
			}
		},
		computed: {
			clientWidth () 
			{
				return (window.innerWidth > 640) ? 640 : window.innerWidth
			},
			buttonsOnLeft () 
			{
				return this.actionButtons.filter(a => ((typeof a.align === 'undefined') || (a.align != 'right')))
			},
			buttonsOnRight ()
			{
				return this.actionButtons.filter(a => ((typeof a.align !== 'undefined') && (a.align == 'right')))
			}
		},
		methods: {
			handleOpenContent ()
			{
				window.open(this.contentUrl, '_blank')
			},
			handleClose () 
			{
				this.$emit('close')
			},
			handleActionClick (action)
			{
				this.$emit(action.eventName, this.contentKeys)
			},
			handleDrawerToggled (value)
			{
				if (!value) this.$emit('close')
			},
			handlePickerAction (value) 
			{
				this.$emit('action', value)
			}
		},
		mounted () {
	        window.addEventListener('keyup', e => {
	            // If  ESC key was pressed...
	            if (e.keyCode === 27) {
	                // try close your dialog
	                this.handleClose()
	            }
	        })
		},
		watch: {
			show (value) {
				this.showPanel = value
			}
		}
	}
</script>

<style lang="scss">
	.v-toolbar__title {
		cursor: pointer;
		user-select: none;
	}
</style>